import API from "./axios";

const customerApi = {
  getAll:      ()              => API.get("/customers"),
  ledger:      (id, params)    => API.get(`/customers/${id}/ledger`, { params }),
  /** Phase 5 — paged register. params: { page, size, sortBy, sortDir, q, isActive, customerType } */
  paged:       (params)        => API.get("/customers/paged", { params }),
  /** Phase 36da.99.cct — per-type counts for the register tabs. params: { q, isActive } */
  typeCounts:  (params)        => API.get("/customers/type-counts", { params }),
  getById:     (id)            => API.get(`/customers/${id}`),
  getByType:   (type)          => API.get(`/customers/type/${type}`),
  create:      (data)          => API.post("/customers", data),
  update:      (id, data)      => API.put(`/customers/${id}`, data),
  toggle:      (id)            => API.patch(`/customers/${id}/toggle-status`),
  delete:      (id)            => API.delete(`/customers/${id}`),
};

export default customerApi;